<template>
    <v-container style="padding: 16px;">
        <v-row class="original-ticket-container">
            <v-col
                class="d-flex"
                cols="6"
                sm="3"
            >
                <v-select
                    v-model="selectedMemberTicketText"
                    label="Member Code"
                    :items="getTicketDetails.Ticket_Text"
                    item-text="member_code"
                    return-object
                    dense
                    outlined
                />
            </v-col>
            <v-col>
                <v-btn
                    class="ma-1 text-subtitle-2 float-right"
                    outlined
                    light
                    :href="getTicketDetails.Tickets.url"
                    target="_blank"
                >
                    View {{ getTicketDetails ? getTicketDetails.Tickets.center : '' }} Link
                </v-btn>
            </v-col>
        </v-row>
        <v-row>
            <pre
                v-if="selectedMemberTicketText"
                class="px-5 ticket-details"
                v-html="getTicketTextHTML"
            />
        </v-row>
    </v-container>
</template>

<script>
import linkifyHtml from 'linkify-html';
import { htmlEncode } from '@/utils/encoding';

export default {
    name: 'OriginalTicket',
    props: {
        ticketDetails: {
            type: Object,
            required: true,
            default: () => ({}),
        }
    },
    data: () => ({
        selectedMemberTicketText: null,
    }),
    computed: {
        getTicketDetails() {
            return this.ticketDetails;
        },
        getTicketTextHTML() {
            if(!this.selectedMemberTicketText.ticket_body) {
                return 'No Ticket Text Found';
            }   
            return linkifyHtml(htmlEncode(this.selectedMemberTicketText.ticket_body));
        }
    },
    watch: { 
        selectedMemberTicketText: {
            handler() {
                if(this.selectedMemberTicketText) {
                    this.$emit('update-selected-ticket-text', this.selectedMemberTicketText);
                }
            }
        },
        getTicketDetails: {
            immediate: true,
            handler() {
                if(this.getTicketDetails) {
                    if(this.getTicketDetails.Ticket_Text) {
                        if(this.getTicketDetails.Ticket_Text.length) {
                            this.selectedMemberTicketText = this.getTicketDetails.Ticket_Text[0];
                        }
                    }
                }
            }
        }
    },
};
</script>

<style>
    .original-ticket-container {
        display: flex;
        justify-content: space-between !important;
        flex-wrap: inherit;
        height: 70px;
    }
    .original-ticket-container .action-btn .v-btn__content {
        color: #122448 !important;
    }
    .ticket-details {
        font-family: 'Courier New', Courier, monospace;
        font-style: normal;
        font-weight: bold;
        font-size: 12px;
        line-height: 20px;
        letter-spacing: 0.004em;
        color: #35383F;
        margin: 16px 0px;
        user-select: text;
    }
</style>